import {
  OpenEnglishLogo,
  OEText,
  flex,
  mt,
  width,
  position,
  left,
} from '@openeducation/oe-rn-components';
import { secondaryFontFamily, styled } from '@openeducation/oe-rn-themes';
import * as React from 'react';
import { View } from 'react-native';

export const PortalLayout: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Container>
      <HeaderContainer>
        <View style={[position('absolute'), left(20)]}>
          <OpenEnglishLogo />
        </View>
        <OEText fontSize={20} fontType="bold" fontFamily={secondaryFontFamily}>
          Private Class
        </OEText>
      </HeaderContainer>
      <View style={[mt(32), width(1120), flex('align-self-center')]}>
        {children}
      </View>
    </Container>
  );
};

const Container = styled.View`
  height: 100%;
  background-color: ${({ theme }) => theme.color.lightPrimary};
`;

const HeaderContainer = styled.View`
  height: 63px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 20px;
  background-color: ${({ theme }) => theme.color.white};
`;
